export const CurrencyInput = ({ label, helper, value, onChange, placeholder, testid, error }) => {
  const display = value == null ? "" : Number(value).toLocaleString("en-US");

  const handleChange = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "");
    onChange(digits === "" ? null : Math.min(Number(digits), 999999999));
  };

  return (
    <div>
      <label htmlFor={testid} className="mb-3 block font-display text-lg font-semibold text-white">
        {label}
      </label>
      <div className="relative">
        <span className="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 font-mono text-2xl text-mint">
          $
        </span>
        <input
          id={testid}
          data-testid={testid}
          inputMode="numeric"
          autoComplete="off"
          value={display}
          onChange={handleChange}
          placeholder={placeholder}
          className={`w-full rounded-2xl border bg-surface py-5 pl-11 pr-5 font-mono text-2xl text-ink shadow-sm outline-none transition-colors duration-300 placeholder:text-ink/30 focus:border-mint ${
            error ? "border-danger" : "border-white/10"
          }`}
        />
      </div>
      {helper && !error && <p className="mt-2 text-xs text-white/40">{helper}</p>}
      {error && (
        <p data-testid={`${testid}-error`} className="mt-2 text-xs text-danger">
          {error}
        </p>
      )}
    </div>
  );
};
